import { render, staticRenderFns } from "./childIndex.vue?vue&type=template&id=ecc62ca4&scoped=true&"
import script from "./childIndex.vue?vue&type=script&lang=js&"
export * from "./childIndex.vue?vue&type=script&lang=js&"
import style0 from "./childIndex.vue?vue&type=style&index=0&id=ecc62ca4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc62ca4",
  null
  
)

export default component.exports